export async function loadActivatedRemoteConfigJson() {
    const loadActivated = globalThis.window?.myFirebaseRemoteConfig?.loadActivated;
    if (!loadActivated) {
        return JSON.stringify({ values: {} });
    }
    return await loadActivated();
}

export async function fetchRemoteConfigJson(forceRefresh) {
    const fetchAndActivate = globalThis.window?.myFirebaseRemoteConfig?.fetchAndActivate;
    if (!fetchAndActivate) {
        return JSON.stringify({ values: {} });
    }
    return await fetchAndActivate(forceRefresh);
}

export function startRemoteConfigUpdates(onUpdate) {
    globalThis.window?.myFirebaseRemoteConfig?.startUpdates?.(onUpdate);
}
